var _rect, _rect2, _rect3, _rect4, _circle, _rect5, _rect6, _rect7, _rect8, _circle2, _g, _rect9, _rect10, _rect11, _rect12, _circle3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStep3Image(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 454,
    height: 402,
    viewBox: "0 0 454 402",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.167,
    y: 0.5,
    width: 377.183,
    height: 82.5154,
    fill: "white",
    stroke: "#BDBDBD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 77.2354,
    y: 18.0833,
    width: 238.016,
    height: 9.53033,
    fill: "#F2F2F2",
    stroke: "#BDBDBD",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 77.2354,
    y: 36.9929,
    width: 238.016,
    height: 9.53033,
    fill: "#F2F2F2",
    stroke: "#BDBDBD",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 77.2354,
    y: 55.9019,
    width: 238.016,
    height: 9.53033,
    fill: "#F2F2F2",
    stroke: "#BDBDBD",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 359.334,
    cy: 41.7578,
    r: 28.1516,
    fill: "#F2F2F2",
    stroke: "#BDBDBD",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 39.167,
    y: 101.349,
    width: 377.183,
    height: 82.5154,
    fill: "white",
    stroke: "#BDBDBD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 77.2354,
    y: 118.932,
    width: 238.016,
    height: 9.53033,
    fill: "#F2F2F2",
    stroke: "#BDBDBD",
    strokeWidth: 1.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 77.2354,
    y: 137.841,
    width: 238.016,
    height: 9.53033,
    fill: "#F2F2F2",
    stroke: "#BDBDBD",
    strokeWidth: 1.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 77.2354,
    y: 156.75,
    width: 238.016,
    height: 9.53033,
    fill: "#F2F2F2",
    stroke: "#BDBDBD",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 359.334,
    cy: 142.607,
    r: 28.1516,
    fill: "#F2F2F2",
    stroke: "#BDBDBD",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 202.198,
    width: 445,
    height: 97.4917,
    fill: "white",
    stroke: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.3496,
    y: 222.889,
    width: 280.967,
    height: 11.5083,
    fill: "#F2F2F2",
    stroke: "#BDBDBD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.3496,
    y: 245.189,
    width: 280.967,
    height: 11.5083,
    fill: "#F2F2F2",
    stroke: "#BDBDBD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.3496,
    y: 267.489,
    width: 280.967,
    height: 11.5083,
    fill: "#F2F2F2",
    stroke: "#BDBDBD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.17,
    cy: 250.942,
    r: 33.3792,
    fill: "#9AFEE0",
    stroke: "#01876F",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.587 256.519L374.737 269.527L400.754 235.148",
    stroke: "#03AA8C",
    strokeWidth: 3
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 39.167,
    y: 318.804,
    width: 377.183,
    height: 82.5154,
    fill: "white",
    stroke: "#BDBDBD"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 77.2354,
    y: 336.387,
    width: 238.016,
    height: 9.53033,
    fill: "#F2F2F2",
    stroke: "#BDBDBD",
    strokeWidth: 1.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 77.2354,
    y: 355.296,
    width: 238.016,
    height: 9.53033,
    fill: "#F2F2F2",
    stroke: "#BDBDBD",
    strokeWidth: 1.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 77.2354,
    y: 374.206,
    width: 238.016,
    height: 9.53033,
    fill: "#F2F2F2",
    stroke: "#BDBDBD",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 359.334,
    cy: 360.061,
    r: 28.1516,
    fill: "#F2F2F2",
    stroke: "#BDBDBD",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 201.698,
    width: 454,
    height: 106.492,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3Image);
export default __webpack_public_path__ + "static/media/Step3-image.9131c5b3c2a76125b1fbf2ddbdfcaa56.svg";
export { ForwardRef as ReactComponent };